<router-outlet featureTabsTabsTitle [prefix]="'tenant-page-title-prefix' | translate"></router-outlet>
<p-confirmDialog key="globalConfirmDialog"></p-confirmDialog>
